module.exports = __webpack_public_path__ + "media/landing_page/top_background-f1cb275a.png";